// utils/encryption.js
import JSEncrypt from "jsencrypt";

export const encryptPassword = (password, publicKey) => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(password); // returns base64
};